// extracted by mini-css-extract-plugin
export default {"container":"DomainsOverlay_container__AumIF","button":"DomainsOverlay_button__EdohK","title":"DomainsOverlay_title__X0m+0","buttons":"DomainsOverlay_buttons__C2QW6"};